module.exports = "/_next/static/images/footer4-42f33bc63f81970e22a083c6d85e823e.svg";